<template>
  <div>
    <div v-if="subsLoading || plansLoading || productsLoading">Loading subscriptions...</div>
    <div v-else-if="hasSubscriptions || dashboardView">
      <SubscriptionList @sub-plan-update="subscriptionPlanUpdated" />
    </div>
    <div v-else id="extra-component-form-wizard">
        <form-wizard-validation />
    </div>
  </div>
</template>

<script>
import helperMethods from '../mixins/helperMethods'

import FormWizardValidation from './forms/form-wizard//FormWizardValidation.vue'
import SubscriptionList from './components/subscription/SubscriptionList'

import { getStripeSubscriptions, getStripePlans, getStripeProducts } from '../stripe/stripeHelperMethods'

export default {
  name: 'Subscription',
  mixins: [
    helperMethods
  ],
  components: {
    FormWizardValidation,
    SubscriptionList
  },
  props: {
    dashboardView: Boolean
  },
  data() {
    return {
      stripeSubscriptions: {},
      hasSubscriptions: false,
      subsLoading: false,
      plansLoading: false,
      productsLoading: false,
      subsError: '',      
      stripePlans: {},
      stripeProducts: [],
    }
  },
  created() {
    // Get Subscriptions from Stripe only if they have not been fetched already
    if (!this.hasData(this.$store.state.AppActiveUser.stripeSubscriptions) && this.$store.state.AppActiveUser.stripe_id) {
      this.loadSubscriptions(this.$store.state.AppActiveUser.stripe_id);
    } else {
      this.stripeSubscriptions = this.$store.state.AppActiveUser.stripeSubscriptions
      this.hasSubscriptions = this.hasData(this.stripeSubscriptions)
      this.$emit('subscription-loaded')
    }

    // Get Plans from Stripe only if they have not been fetched already
    if (!this.hasData(this.$store.state.AppActiveUser.stripePlans)) {
      this.loadPlans();
    } else {
      this.stripePlans = this.$store.state.AppActiveUser.stripePlans
    }

    // Get Products from Stripe only if they have not been fetched already
    if (!this.hasData(this.$store.state.AppActiveUser.stripeProducts)) {
      this.loadProducts();
    } else {
      this.stripeProducts = this.$store.state.AppActiveUser.stripeProducts
    }
  },
  methods: {
    loadSubscriptions(stripeCustomerId) {
      this.subsLoading = true

      getStripeSubscriptions(stripeCustomerId)  
        .then (result => {
          //console.log('subscription GET result:', result)
          this.stripeSubscriptions = (result.data.data && result.data.data.length > 0) ? result.data : {};
          this.hasSubscriptions = this.hasData(this.stripeSubscriptions)
          this.$store.commit('UPDATE_USER_INFO', { stripeSubscriptions: this.stripeSubscriptions, hasSubscriptions: this.hasSubscriptions }, { root: true })
          this.$emit('subscription-loaded')
        }).catch(err => {
          this.subsError = 'Error occured while fetching subscriptions: ' + err.response.data.raw.message
          this.hasSubscriptions = false
        }).finally(() => {
          this.subsLoading = false
        })
    },
    loadPlans() {
      this.plansLoading = true

      getStripePlans()
        .then (result => {
          //console.log('Stripe plans GET result:', result)
          this.stripePlans = result.data
          this.$store.commit('UPDATE_USER_INFO', { stripePlans: this.stripePlans }, { root: true })
        }).catch(err => {
          console.log('Error occured while getting Stripe plans:', err.response.data.raw.message)
        }).finally(() => {
          this.plansLoading = false
        })
    },
    loadProducts() {
      this.productsLoading = true

      getStripeProducts()
        .then (result => {
          //console.log('Stripe products GET result:', result)
          this.stripeProducts = result.data
          this.$store.commit('UPDATE_USER_INFO', { stripeProducts: this.stripeProducts }, { root: true })
        }).catch(err => {
          console.log('Error occured while getting Stripe products:', err.response.data.raw.message)
        }).finally(() => {
          this.productsLoading = false
        })
    },
    subscriptionPlanUpdated(updatedSubs) {
      this.$emit('sub-plan-update', updatedSubs)
    }
  }
}
</script>